import { render, staticRenderFns } from "./message_set.vue?vue&type=template&id=57f50aa3&scoped=true"
import script from "./message_set.vue?vue&type=script&lang=js"
export * from "./message_set.vue?vue&type=script&lang=js"
import style0 from "./message_set.vue?vue&type=style&index=0&id=57f50aa3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f50aa3",
  null
  
)

export default component.exports